<template>
  <div class="search-container">
    <div class="search-left">
      <!-- 渠道id/渠道名称 -->
      <el-input v-model="searchParams.search" size="small" placeholder="渠道id/渠道名称"
        style="width: 200px;margin-right: 20px;" clearable></el-input>
      <!-- 标签 1-白名单 2-灰名单 3-黑名单, 下拉选择-->
      <el-select v-model="searchParams.label" size="small" placeholder="标签" style="margin-right: 20px;" clearable>
        <el-option label="白名单" value="1"></el-option>
        <el-option label="灰名单" value="2"></el-option>
        <el-option label="黑名单" value="3"></el-option>
      </el-select>
    </div>
    <div class="search-right">
      <el-button type="primary" v-auth="'SECURITY_MANAGE_CHANNEL_MANAGE_SEARCH'" size="small" @click="search"
        :loading="list.loading">查询</el-button>
      <el-button size="small" v-auth="'SECURITY_MANAGE_CHANNEL_MANAGE_ADD'" @click="add">新增</el-button>
    </div>
    <Add ref="add" />
  </div>
</template>

<script>
import Add from './add.vue';
export default {
  name: 'WebSaaSSearch',

  inject: ['searchParams', 'loadList', 'list'],
  components: {
    Add
  },
  data() {
    return {

    };
  },



  methods: {
    /** 搜索 */
    search() {
      this.searchParams.current = 1
      this.loadList();
    },
    /** 新增 */
    add() {
      this.$refs.add.show();
    },
  },
};
</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  margin-bottom: 20px;

  .search-left {
    flex: 1;
    display: flex;
  }

  .search-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
